import { render, staticRenderFns } from "./BlackListResult.vue?vue&type=template&id=72d3581e&scoped=true"
import script from "./BlackListResult.vue?vue&type=script&lang=js"
export * from "./BlackListResult.vue?vue&type=script&lang=js"
import style0 from "./BlackListResult.vue?vue&type=style&index=0&id=72d3581e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d3581e",
  null
  
)

export default component.exports